import asyncComponent from '../../components/AsyncComponent';

const ContractView = asyncComponent(() => import('../../containers/Contract/View'));

export default ContractView;
